/**
* In this file use to contains the physician Module Notification screen UI and Logic
**/
import { Link, useNavigate } from 'react-router-dom';
import { goBack } from './../../../services/UtilsService';
import { useState,useEffect } from 'react';
import ApiService from './../../../services/ApiService';
import Pagination from './../../../shared/components/Pagination';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import 'moment/locale/ta';
moment.updateLocale('ta', {
  preparse: function (string) {
    return string;
  },
  postformat: function (string) {
    return string.replace(/[௦௧௨௩௪௫௬௭௮௯]/g, function (match) {
      return {
        '௦': '0',
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
      }[match];
    });
  },
});

function Notification() {
	
	//Intial state declaraction
	const [notificationList,setNotificationList]=useState([]);
	const [param,setParam]=useState({page:0,limit:10});
	const navigate=useNavigate();
	const { t } = useTranslation();
	const currentLang = localStorage.getItem('i18nextLng');
	const role = Number(localStorage.getItem('role'));
	const currentUrl = window.location.href;

	/** 
	* To handle pagination event
	* @data we pass the page number
	**/
	  const handlePaginate=(data)=>{  
		  setParam({...param,page:data});
	  };
	  
	  /** 
	  * Notification Search handeonChange
	  * @e we get the event details from the change action
	  **/
	const handleChange =async (e) => {
		e.preventDefault();
		const {name,value}=e.target;  
		setParam({...param,[name]:value,page:0});
	};
	
	/** 
	* handleDelete Notification
	* @e we get the event details from the click action
	* @id we pass the Notification record id
	**/
	const handleDelete =async (e,id) => {
		e.preventDefault();
		const response = await ApiService.deleteNotification(id);
		if(response.status===200){
			await loadNotification();
			toast.success(response?.data?.message);
		}
	};
	
	/** 
	* To navigate to member profile while click the Notification
	* @member we pass the member id
	**/
	/*const navigateMember = (member)=>{
		navigate('/physician/member-profile/'+member);
	}*/
	
	/** 
	* To navigate to particular module while click the Notification
	* @member we pass the member id
	**/
	const navigateAppointment = (module,member)=>{
		if(module === 'Appointment'){
			navigate('/physician/appointments');
		}else if(module === 'Vaccination'){
			navigate('/physician/vaccination');
		}else if(module === 'Development Milestones'){
			navigate('/physician/development');
		}else if(module === 'Diagnosis'){
			navigate('/physician/member-profile/'+member);
		}
	}
	
	/** 
	* To view Notification
	* @e we get the event details from the click action
	* @data we pass the Notification record id and member id in Object format {id:item.id,member:item.member}
	**/
	const handleView =async (e,data) => {
		e.preventDefault();
		const response = await ApiService.viewNotification(data.id);
		if(response.status===200){
			// Always call loadNotification() first for hospial admin
			if (role === 4) {
				await loadNotification();
			}

			if(data.mapping===true){
				navigateAppointment(data.module,data.member);	
			}else{
				if (role !== 4) {
					await loadNotification(); // for other roles (if not already called)
				}
				toast.success(response?.data?.message);	
			}
		}
	};
	
	/** 
	* handeonChange while dropdown change
	* @e we get the event details from the change action
	**/
	 const handleSortChange = (e) => {
		 e.preventDefault();
		const {name,value}=e.target;  
		setParam({...param,[name]:value,page:0});
	  };
	  
	 //Component Initialize function trigger when param details change
	useEffect(()=>{(async () => {
		await loadNotification();
		})();
		// eslint-disable-next-line
	},[param]);
	
	/*To load the Notification  Details from the api call*/
	 const loadNotification = async() => {
		 const response = await ApiService.getNotification(param);
		if(response.status===200){
			setNotificationList(response.data);	
		}
	  };
   
  return (
    <>
	<main id="main" className="main">
		{/*Page Title Section*/}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('sidebar.notification')}</h1>
				<nav>
					<ol className="breadcrumb">
					  	<li className="breadcrumb-item">
							<Link to={currentUrl.includes('/parent/') ? '/parent/dashboard' : currentUrl.includes('/physician/') ? '/physician/dashboard' : '/hospital/admin/dashboard'}>
								{t('sidebar.home')}
							</Link>
						</li>
					  	<li className="breadcrumb-item active">{t('sidebar.notification')} </li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
		</div>
		{/*End Page Title Section*/}
		
		{/*Page Content Section*/}
		<section className="pagesection">
			<div className="row my-3">
				<div className="col-xxl-7 col-lg-7 d-flex">
					<div className="input-group input-group-sm me-2 w-50">
					  <input type="text"  name="search" value={param.search?param.search:''} onChange={handleChange} className="form-control" placeholder={t('common.search')} />
					  <button className={`btn ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmBlue'}`} type="button">
						<i className="ri-search-line align-middle"></i>
					  </button>
					</div>
				</div>
				<div className="col-xxl-5 col-lg-5">
					<div className="dropdown float-end">
					  <button className={`btn btn-sm dropdown-toggle ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'}`} type="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
						  {t('common.filter')}
						</button>

					  <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
						<li>
						<button className={(param.fliter==="" || !param.fliter ) ? 'dropdown-item active' : 'dropdown-item'} type="button" value="" name="fliter" onClick={handleSortChange} > {t('common.all')} </button>
						</li>
						<li>
						<button className={param.fliter==="1" ? 'dropdown-item active' : 'dropdown-item'} type="button" value="1" name="fliter" onClick={handleSortChange} > {t('common.recent')} </button>
						</li>
						<li>
						<button className={param.fliter==="7" ? 'dropdown-item active' : 'dropdown-item'} type="button" value="7" name="fliter" onClick={handleSortChange} > {t('common.lastFewDays')} </button>
						</li>
						<li>
						<button className={param.fliter==="15" ? 'dropdown-item active' : 'dropdown-item'} type="button" value="15" name="fliter" onClick={handleSortChange} > {t('common.lastFewWeek')} </button>
						</li>
					  </ul>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-lg-12">
					<ul className="notificSec">
					{notificationList && notificationList.items && notificationList.items.length > 0 ? (
					notificationList.items.map((item, i) => (
					  <li key={i} className={item?.status === 0 ? 'nBox unRead':'nBox'}>
							<div className="nIcon">
								<i className="iconly-Light-TickSquare text-success"></i>
							</div>
							<div className="nInfo" onClick={(e) => item.status !== 1 ? handleView(e, {id:item.id,member:item.member,mapping:item.mapping,module:item.module}):navigateAppointment(item.module,item.member)}>
								<h6 className="text text-capitalize">{currentLang === 'ta' ? item.module_tamil || item.module : item.module} {t('sidebar.notification')}</h6>
								<p>{currentLang === 'ta' ? item.message_tamil || item.message : item.message} </p>
								<p><small>{moment(item.createdAt).fromNow()}</small></p>
							</div>
							<div className="nDelt">
								<i className="ri-delete-bin-7-line" onClick={(e)=>handleDelete(e,item.id)}></i>
							</div>
						</li>
					))
				  ) : (
					<li className="text-center">{t('common.noRecord')}</li> 
				  )}
					</ul>
					{/*Pagination*/}
					{notificationList && notificationList.length !==0 && notificationList?.items?.length!==0 && <div className="row my-3">
						<div className="col-xxl-12 d-flex justify-content-center">
							<Pagination page={param.page} handlePaginate={handlePaginate} total={notificationList.count}  />
						</div>
					</div>}
				{/*End Pagination*/}
				</div>
			</div>
		</section>
		{/*End Page Content Section*/}
	</main>
	
    </>
  );
}

export default Notification;
